export const state = () => ({
  openId: '',
  userInfo: {}
})

export const getters = {
  getterValue: (state) => {
    return state.openId
  }
}

export const mutations = {
  updateOpenId: (state, payload) => {
    state.openId = payload
  },
  updateUserInfo: (state, payload) => {
    state.userInfo = payload
  }
}

export const actions = {
  updateActionOpenId({ commit }, payload) {
    commit('updateOpenId', payload)
  },
  updateActionUserInfo({ commit }, payload) {
    commit('updateUserInfo', payload)
  }
}

export const namespaced = true
